import React, { useRef, useState } from 'react';
import './newform.css';
import ColorPicker from '../ColorPicker/colorpicker';
import FilePicker from '../FilePicker/filepicker';
import FontPicker from '../FontPicker/fontpicker';

/**
 * Renders a form for creating new text objects.
 * It includes fields for text input, color selection, font choice, and text positioning.
 * @param {Object} props - The properties passed to the component.
 * @param {function} props.onSubmit - Callback function to handle form submission with the form data.
 * @returns {JSX.Element} The rendered NewFormComponent.
 */
const NewFormComponent = ({onSubmit}) => {
    const txtInput = useRef(null);
    const [errors, setErrors] = useState(null);

    const onSubmitHandler = e => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);        
        
            // Validation - so far only checks if text is entered
            // It doesn't even matter because everything can be changed later
            // TODO: Remove ??
            const formGet = attr => formData.get(attr);
            let errs = [];
            if (!formGet('usertext')) {
                errs.push('You need to type something');
            };
            if ( errs.length ) {
                setErrors(errs);
                return;
            }else{
                setErrors(null);
            }

        formData.append('fontSize', 20);
        onSubmit(formData);
        txtInput.current.value = '';
    }

    return (
    <form onSubmit={onSubmitHandler} className='form-list'>

        <div className='title-container'>
            <h4>New Text</h4>
            <small>Add new text to your meme.</small>
        </div>

        <div id='color-container'>
            <label htmlFor='color'>Text Color</label>
            <ColorPicker txt_id='color' name='txt_color' color='White' />
        </div>

        <div id='strokeColor-container'>
            <label htmlFor='color'>Shadow Color</label>
            <ColorPicker txt_id='stroke' name='stroke_color' color='Black' />
        </div>

        <div id='font-container'>
            <FontPicker name={'font'}/>
        </div>
        
        <label htmlFor='position'>Text Position
            <select id='position' name='position' defaultValue='top'>
                <option value='top'>Top</option>
                <option value='middle'>Middle</option>
                <option value='bottom'>Bottom</option>
            </select>
        </label>

        <label htmlFor='align'>Text Alignment
            <select id='align' name='align' defaultValue='center'>
                <option value='left'>Left</option>
                <option value='center'>Center</option>
                <option value='right'>Right</option>
            </select>
        </label>

        <label htmlFor='valign'>Text Vertical Alignment
            <select id='vAlign' name='vAlign' defaultValue='middle'>
                <option value='top'>Top</option>
                <option value='bottom'>Bottom</option>
                <option value='middle'>Middle</option>
            </select>
        </label>        

        <label htmlFor='txt-input'>Text
        <textarea
            ref={txtInput}
            className='txt-input'
            name='usertext'
            placeholder='Your text here'
            spellCheck={false}
        ></textarea>
        </label>
        { errors && errors.map(( msg, i )=>(
            <div key={i} className='form-error'>{msg}</div>
        ) )}
        <button style={{marginTop:'12px'}}type='submit'>Create Text</button>
    </form>
    )
}

export default NewFormComponent;